import React, { useEffect } from 'react';
import { MainTable } from '../../../Components/MainTable/MainTable';
import Add from './Add';
import Edit from './Edit';
import { useUnits } from './UnitStore';

function Units(props) {
    let { units, columns, getUnits, deleteUnit, setEd } = useUnits();
    useEffect(() => {
        getUnits()
    }, [])
    return (
        <MainTable
            pageTitle="O'lchov birliklari"
            pcolumns={columns}
            pdata={units}
            add={<Add />}
            edit={<Edit />}
            defkey={'id'}
            onDelete={(e, rec) => {
                deleteUnit(rec.id)
            }}
            onEdit={(rec) => {
                setEd(rec)
            }}
            setEd={setEd}
        />
    );
}

export default Units;